import clsx from 'clsx';
import React from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBAnimationProps } from '../base';

/*
    Using CSS animations, web will be more performant

    TODO(fant): the CSS animation is declared in frontend/web/src/index.css
    Ideally the css file is in this folder (import './index.css') but that
    does not work well with typescript (since ./build/../index.css) won't exist.
*/
export function MBAnimationSpin({ children, style, animationClass }: MBAnimationProps) {
  return (
    <View shrinkWrap>
      <div className={clsx('MBAnimation MBAnimationSpin', animationClass)}>
        <MBView style={style}>{children}</MBView>
      </div>
    </View>
  );
}
